// extracted by mini-css-extract-plugin
module.exports = {"svg":"SpotLoader_svg__ZqIl7","circle":"SpotLoader_circle__Zajtn"};